import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getStaffPortalSession } from './staffPortalSession';

/** Redirects to /admin if there is no staff portal session. */
export function useStaffPortalGuard() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!getStaffPortalSession()) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);
}
